import { createContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
export const defaultModalContext = {
  use: 'default',
  headerCallback: emptyFunction
};
export const ModalContext = /*#__PURE__*/createContext(defaultModalContext);
const {
  Provider
} = ModalContext;
export { Provider as ModalContextProvider };